"use client";

import { useState } from "react";
import Icon from "@/components/ui/AppIcon";


interface Vehicle {
  id: string;
  vehicleId: string;
  make: string;
  model: string;
  year: number;
  registrationNumber: string;
  status: "compliant" | "expiring" | "expired";
  expiryDate: string;
  daysUntilExpiry: number;
  imageUrl: string;
  color: string;
}

// Generate 20,000 vehicles with proper make-model-image mapping
const generateVehicles = (): Vehicle[] => {
  // Proper vehicle data with matching images
  const vehicleData = [
    // Toyota models
    { make: "Toyota", model: "Camry", imageUrl: "https://images.unsplash.com/photo-1621007947382-bb3c3994e3fb?w=200&h=150&fit=crop", color: "#DC2626" },
    { make: "Toyota", model: "Corolla", imageUrl: "https://images.unsplash.com/photo-1623869675781-80aa31012a5a?w=200&h=150&fit=crop", color: "#1E40AF" },
    { make: "Toyota", model: "RAV4", imageUrl: "https://images.unsplash.com/photo-1616422285623-13ff0162193c?w=200&h=150&fit=crop", color: "#059669" },
    
    // BMW models
    { make: "BMW", model: "3 Series", imageUrl: "https://images.unsplash.com/photo-1555215695-3004980ad54e?w=200&h=150&fit=crop", color: "#374151" },
    { make: "BMW", model: "X5", imageUrl: "https://images.unsplash.com/photo-1617531653520-bd466ee81a7d?w=200&h=150&fit=crop", color: "#0891B2" },
    { make: "BMW", model: "M4", imageUrl: "https://images.unsplash.com/photo-1617814076367-b759c7d7e738?w=200&h=150&fit=crop", color: "#7C3AED" },
    
    // Mercedes-Benz models
    { make: "Mercedes-Benz", model: "C-Class", imageUrl: "https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=200&h=150&fit=crop", color: "#64748B" },
    { make: "Mercedes-Benz", model: "E-Class", imageUrl: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=200&h=150&fit=crop", color: "#78716C" },
    { make: "Mercedes-Benz", model: "GLE", imageUrl: "https://images.unsplash.com/photo-1609521263047-f8f205293f24?w=200&h=150&fit=crop", color: "#1E40AF" },
    
    // Audi models
    { make: "Audi", model: "A4", imageUrl: "https://images.unsplash.com/photo-1610768764270-790fbec18178?w=200&h=150&fit=crop", color: "#EF4444" },
    { make: "Audi", model: "Q5", imageUrl: "https://images.unsplash.com/photo-1614200179396-2bdb77ebf81b?w=200&h=150&fit=crop", color: "#10B981" },
    { make: "Audi", model: "A6", imageUrl: "https://images.unsplash.com/photo-1603584173870-7f23fdae1b7a?w=200&h=150&fit=crop", color: "#3B82F6" },
    
    // Tesla models
    { make: "Tesla", model: "Model 3", imageUrl: "https://images.unsplash.com/photo-1560958089-b8a1929cea89?w=200&h=150&fit=crop", color: "#DC2626" },
    { make: "Tesla", model: "Model Y", imageUrl: "https://images.unsplash.com/photo-1617788138017-80ad40651399?w=200&h=150&fit=crop", color: "#1E40AF" },
    { make: "Tesla", model: "Model S", imageUrl: "https://images.unsplash.com/photo-1536700503339-1e4b06520771?w=200&h=150&fit=crop", color: "#374151" },
    
    // Ford models
    { make: "Ford", model: "Mustang", imageUrl: "https://images.unsplash.com/photo-1584345604476-8ec5f5d3e0c0?w=200&h=150&fit=crop", color: "#EA580C" },
    { make: "Ford", model: "F-150", imageUrl: "https://images.unsplash.com/photo-1593450315184-6f9e6ce937d5?w=200&h=150&fit=crop", color: "#0284C7" },
    { make: "Ford", model: "Explorer", imageUrl: "https://images.unsplash.com/photo-1619405399517-d7fce0f13302?w=200&h=150&fit=crop", color: "#059669" },
    
    // Honda models
    { make: "Honda", model: "Civic", imageUrl: "https://images.unsplash.com/photo-1590362891991-f776e747a588?w=200&h=150&fit=crop", color: "#4F46E5" },
    { make: "Honda", model: "Accord", imageUrl: "https://images.unsplash.com/photo-1619682817481-e994891cd1f5?w=200&h=150&fit=crop", color: "#BE123C" },
    { make: "Honda", model: "CR-V", imageUrl: "https://images.unsplash.com/photo-1605559424843-9e4c228bf1c2?w=200&h=150&fit=crop", color: "#15803D" },
    
    // Porsche models
    { make: "Porsche", model: "911", imageUrl: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=200&h=150&fit=crop", color: "#CA8A04" },
    { make: "Porsche", model: "Cayenne", imageUrl: "https://images.unsplash.com/photo-1611859266238-4b98091d9d9b?w=200&h=150&fit=crop", color: "#64748B" },
    { make: "Porsche", model: "Macan", imageUrl: "https://images.unsplash.com/photo-1580273916550-e323be2ae537?w=200&h=150&fit=crop", color: "#9333EA" },
    
    // Volkswagen models
    { make: "Volkswagen", model: "Golf", imageUrl: "https://images.unsplash.com/photo-1622353219448-46a009f0d44f?w=200&h=150&fit=crop", color: "#1E40AF" },
    { make: "Volkswagen", model: "Tiguan", imageUrl: "https://images.unsplash.com/photo-1625231334168-35067f8853ed?w=200&h=150&fit=crop", color: "#DC2626" },
    { make: "Volkswagen", model: "Passat", imageUrl: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=200&h=150&fit=crop", color: "#059669" },
    
    // Volvo models
    { make: "Volvo", model: "XC90", imageUrl: "https://images.unsplash.com/photo-1542362567-b07e54358753?w=200&h=150&fit=crop", color: "#7C3AED" },
    { make: "Volvo", model: "S60", imageUrl: "https://images.unsplash.com/photo-1606220838315-056192d5e927?w=200&h=150&fit=crop", color: "#0891B2" },
    { make: "Volvo", model: "XC60", imageUrl: "https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=200&h=150&fit=crop", color: "#374151" },
  ];
  
  const statuses: ("compliant" | "expiring" | "expired")[] = ["compliant", "expiring", "expired"];
  
  const vehicles: Vehicle[] = [];
  
  for (let i = 1; i <= 20000; i++) {
    // Cycle through vehicle data to ensure variety
    const vehicleTemplate = vehicleData[i % vehicleData.length];
    const year = 2018 + Math.floor(Math.random() * 7); // 2018-2024
    const status = statuses[Math.floor(Math.random() * statuses.length)];
    
    let daysUntilExpiry: number;
    if (status === "compliant") {
      daysUntilExpiry = 60 + Math.floor(Math.random() * 300);
    } else if (status === "expiring") {
      daysUntilExpiry = 1 + Math.floor(Math.random() * 30);
    } else {
      daysUntilExpiry = -1 - Math.floor(Math.random() * 60);
    }
    
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + daysUntilExpiry);
    
    const letters = String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
                    String.fromCharCode(65 + Math.floor(Math.random() * 26)) +
                    String.fromCharCode(65 + Math.floor(Math.random() * 26));
    const numbers = String(1000 + Math.floor(Math.random() * 9000));
    
    vehicles.push({
      id: `veh_${String(i).padStart(5, '0')}`,
      vehicleId: `VH-${String(i).padStart(5, '0')}`,
      make: vehicleTemplate.make,
      model: vehicleTemplate.model,
      year,
      registrationNumber: `${letters}-${numbers}`,
      status,
      expiryDate: expiryDate.toISOString().split('T')[0],
      daysUntilExpiry,
      imageUrl: vehicleTemplate.imageUrl,
      color: vehicleTemplate.color
    });
  }
  
  return vehicles;
};

export default function VehicleTable() {
  const [searchTerm, setSearchTerm] = useState("");
  const [filterStatus, setFilterStatus] = useState<string>("all");
  const [sortField, setSortField] = useState<keyof Vehicle>("expiryDate");
  const [sortDirection, setSortDirection] = useState<"asc" | "desc">("asc");
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 50;

  const vehicles = generateVehicles();

  const statusConfig = {
    compliant: {
      label: "Compliant",
      color: "bg-emerald-50 text-emerald-700 border-emerald-200",
      dotColor: "bg-emerald-500",
    },
    expiring: {
      label: "Expiring Soon",
      color: "bg-amber-50 text-amber-700 border-amber-200",
      dotColor: "bg-amber-500",
    },
    expired: {
      label: "Expired",
      color: "bg-rose-50 text-rose-700 border-rose-200",
      dotColor: "bg-rose-500",
    },
  };

  const filteredVehicles = vehicles
    .filter((vehicle) => {
      const matchesSearch =
        vehicle.vehicleId.toLowerCase().includes(searchTerm.toLowerCase()) ||
        vehicle.registrationNumber.toLowerCase().includes(searchTerm.toLowerCase()) ||
        `${vehicle.make} ${vehicle.model}`.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesFilter = filterStatus === "all" || vehicle.status === filterStatus;
      return matchesSearch && matchesFilter;
    })
    .sort((a, b) => {
      const aValue = a[sortField];
      const bValue = b[sortField];
      const modifier = sortDirection === "asc" ? 1 : -1;
      return aValue > bValue ? modifier : -modifier;
    });

  const totalPages = Math.ceil(filteredVehicles.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedVehicles = filteredVehicles.slice(startIndex, endIndex);

  const handleSort = (field: keyof Vehicle) => {
    if (sortField === field) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortField(field);
      setSortDirection("asc");
    }
  };

  const goToPage = (page: number) => {
    setCurrentPage(Math.max(1, Math.min(page, totalPages)));
  };

  const getPageNumbers = () => {
    const pages: (number | string)[] = [];
    const maxVisible = 7;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 4) {
        for (let i = 1; i <= 5; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      } else if (currentPage >= totalPages - 3) {
        pages.push(1);
        pages.push('...');
        for (let i = totalPages - 4; i <= totalPages; i++) pages.push(i);
      } else {
        pages.push(1);
        pages.push('...');
        for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i);
        pages.push('...');
        pages.push(totalPages);
      }
    }
    
    return pages;
  };

  return (
    <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
      {/* Filters & Search */}
      <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-blue-50 to-indigo-50">
        <div className="flex flex-col md:flex-row gap-4">
          {/* Search */}
          <div className="flex-1 relative">
            <Icon
              name="MagnifyingGlassIcon"
              className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
              size={20}
            />
            <input
              type="text"
              placeholder="Søk etter kjøretøy-ID, registrering eller merke/modell..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2.5 bg-white border border-gray-300 rounded-lg text-gray-900 placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            />
          </div>

          {/* Status Filter */}
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="px-4 py-2.5 bg-white border border-gray-300 rounded-lg text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          >
            <option value="all">Alle statuser</option>
            <option value="compliant">Compliant</option>
            <option value="expiring">Utløper snart</option>
            <option value="expired">Utløpt</option>
          </select>
        </div>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Kjøretøy
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                <button
                  onClick={() => handleSort("vehicleId")}
                  className="flex items-center gap-2 hover:text-gray-900 transition-colors"
                >
                  Kjøretøy-ID
                  <Icon name="ChevronUpDownIcon" size={14} />
                </button>
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                <button
                  onClick={() => handleSort("make")}
                  className="flex items-center gap-2 hover:text-gray-900 transition-colors"
                >
                  Merke/Modell
                  <Icon name="ChevronUpDownIcon" size={14} />
                </button>
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Registrering #
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Status
              </th>
              <th className="px-6 py-4 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                <button
                  onClick={() => handleSort("expiryDate")}
                  className="flex items-center gap-2 hover:text-gray-900 transition-colors"
                >
                  Utløpsdato
                  <Icon name="ChevronUpDownIcon" size={14} />
                </button>
              </th>
              <th className="px-6 py-4 text-right text-xs font-semibold text-gray-600 uppercase tracking-wider">
                Handlinger
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {paginatedVehicles.map((vehicle) => (
              <tr
                key={vehicle.id}
                className="hover:bg-blue-50/50 transition-colors"
              >
                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center gap-3">
                    <div className="w-3 h-3 rounded-full shadow-sm" style={{ backgroundColor: vehicle.color }}></div>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="font-mono text-sm font-semibold text-gray-900">
                    {vehicle.vehicleId}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div>
                    <p className="font-medium text-gray-900">
                      {vehicle.make} {vehicle.model}
                    </p>
                    <p className="text-sm text-gray-500">{vehicle.year}</p>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <span className="font-mono text-sm text-gray-900">
                    {vehicle.registrationNumber}
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div
                    className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full border text-xs font-semibold ${
                      statusConfig[vehicle.status].color
                    }`}
                  >
                    <span className={`w-2 h-2 rounded-full ${statusConfig[vehicle.status].dotColor}`}></span>
                    {statusConfig[vehicle.status].label}
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <div>
                    <p className="text-sm font-medium text-gray-900">
                      {new Date(vehicle.expiryDate).toLocaleDateString("nb-NO", {
                        month: "short",
                        day: "numeric",
                        year: "numeric",
                      })}
                    </p>
                    <p className="text-xs text-gray-500">
                      {vehicle.daysUntilExpiry > 0
                        ? `${vehicle.daysUntilExpiry} dager igjen`
                        : `${Math.abs(vehicle.daysUntilExpiry)} dager forsinket`}
                    </p>
                  </div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-right">
                  <div className="flex items-center justify-end gap-2">
                    <button className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
                      <Icon name="EyeIcon" size={18} />
                    </button>
                    <button className="p-2 text-gray-500 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors">
                      <Icon name="PencilIcon" size={18} />
                    </button>
                    <button className="p-2 text-gray-500 hover:text-rose-600 hover:bg-rose-50 rounded-lg transition-colors">
                      <Icon name="TrashIcon" size={18} />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Empty State */}
      {filteredVehicles.length === 0 && (
        <div className="p-12 text-center">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="MagnifyingGlassIcon" className="text-gray-400" size={32} />
          </div>
          <p className="text-gray-900 font-medium mb-2">Ingen kjøretøy funnet</p>
          <p className="text-gray-500 text-sm">
            Prøv å justere søke- eller filterkriteriene dine
          </p>
        </div>
      )}

      {/* Pagination */}
      {filteredVehicles.length > 0 && (
        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between bg-gray-50">
          <p className="text-sm text-gray-600">
            Viser <span className="font-semibold text-gray-900">{startIndex + 1}</span> til{" "}
            <span className="font-semibold text-gray-900">{Math.min(endIndex, filteredVehicles.length)}</span> av{" "}
            <span className="font-semibold text-gray-900">{filteredVehicles.length}</span> kjøretøy
          </p>
          <div className="flex items-center gap-2">
            <button
              onClick={() => goToPage(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent"
            >
              Forrige
            </button>
            
            {getPageNumbers().map((page, index) => (
              page === '...' ? (
                <span key={`ellipsis-${index}`} className="px-2 text-gray-500">...</span>
              ) : (
                <button
                  key={page}
                  onClick={() => goToPage(page as number)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                    currentPage === page
                      ? "bg-blue-600 text-white" :"border border-gray-300 text-gray-700 hover:bg-white"
                  }`}
                >
                  {page}
                </button>
              )
            ))}
            
            <button
              onClick={() => goToPage(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-transparent"
            >
              Neste
            </button>
          </div>
        </div>
      )}
    </div>
  );
}